import { Segment } from '../core/core';
import Notifications from '../components/Notifications';

import styles from './NotificationsPage.module.scss';
import utilityStyles from '../SCSS/common/utilityStyles.module.scss';
import segmentStyles from '../SCSS/Segment.module.scss';

interface Props {
  isAuthenticated: boolean;
}

const NotificationsPage = ({ isAuthenticated }: Props) => {
  return !isAuthenticated ? null : (
    <div className={`${styles.pageContainer} ${utilityStyles.clearfix}`}>
      <div className='spacer-30' />
      <Segment className={utilityStyles.line}>
        <div>
          <div className='vcenter'>
            <div className={segmentStyles.moduleTitle}>Notifications</div>
          </div>
        </div>
      </Segment>
      <div className={styles.notificationsContainer}>
        <Notifications />
      </div>
      <div className='spacer' />
    </div>
  );
};

export default NotificationsPage;
